/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackActions from '../../actions/trackActions';

class PlayPauseButtons extends Component {
    
    constructor(props, context) {
        super(props, context);
        this.playPause = this.playPause.bind(this);
        this.trackPlaying = this.trackPlaying.bind(this);
    }

    componentDidMount() {
    
    }          
    
    shouldComponentUpdate(nextProps, nextState) {
        //we're now playing and the playing state has changed or we're playing next or we're changing the track and we were either playing now or next
        const playingNow = this.props.nowPlaying && this.props.nowPlaying.ID == this.props.trackID;
        const playingStateChanged = this.props.trackPlaying != nextProps.trackPlaying || this.props.trackPaused != nextProps.trackPaused;
        const playingNext = nextProps.nowPlaying && nextProps.nowPlaying.ID == this.props.trackID;
        const trackChanged = this.props.nowPlaying && nextProps.nowPlaying && this.props.nowPlaying.ID != nextProps.nowPlaying.ID;
        return (playingNow && playingStateChanged) || playingNext || ((playingNow || playingNext) && trackChanged);
    }

    /*componentWillUpdate(nextProps, nextState) {
        this.trackID = nextProps.trackID;
    }*/
    
    playPause(e, trackID) {        
        e.preventDefault();
        let currentProfileID;
        if(this.props.user && this.props.user.activeProfile) {
            currentProfileID = this.props.user.activeProfile.ID;
        }
        if(trackID) {
            this.props.actions.playPauseTrack(trackID, currentProfileID);
        }
        //we're either playing nothing, playing a different track, or the track has finished playing
        /*if(this.props.nowPlaying.ID != trackID || (!this.props.trackPlaying && !this.props.trackPaused)) {
            this.props.actions.playTrack(trackID);
            $('body').addClass('showplayer');
            if(this.props.nowPlaying.ID == trackID && (!this.props.trackPlaying && !this.props.trackPaused)) {
                //we're resuming but want to hit the server as it ended and we're replaying so want to log the play
                //we won't do anything with the response as the ID hasn't changed, so trigger the status back to played
                this.props.actions.setTrackStatus(true, false);
            }
        }
        else if(this.props.trackPlaying) {
            //pause the track
            this.props.actions.setTrackStatus(false, true);
        }
        else if(this.props.trackPaused) {
            //resume the track
            this.props.actions.setTrackStatus(true, false);
        }*/
    }

    trackPlaying() {
        return this.props.nowPlaying.ID == this.props.trackID && this.props.trackPlaying;
    }

    render() {
        return (
            <a href="#" className={this.props.anchorClass} onClick={(event) => this.playPause(event, this.props.trackID)}>
                <span className={this.props.spanClass}>
                    <svg className={this.props.playButtonClass} style={{display:!this.trackPlaying() ? 'inline' : 'none'}}>
                        <use xlinkHref="#icn-play" />
                    </svg>
                    <svg className={this.props.pauseButtonClass} style={{display:this.trackPlaying() ? 'inline' : 'none'}}>
                        <use xlinkHref="#icn-pause" />
                    </svg>
                </span>
            </a>
        );
    }
}

PlayPauseButtons.propTypes = {
    trackID: PropTypes.number,
    anchorClass: PropTypes.string.isRequired,
    spanClass: PropTypes.string,
    playButtonClass: PropTypes.string.isRequired,
    pauseButtonClass: PropTypes.string.isRequired,
    nowPlaying: PropTypes.object,
    trackPlaying: PropTypes.bool.isRequired,
    trackPaused: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    user: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return { 
        nowPlaying: state.tracks.nowPlaying, 
        trackPlaying: state.tracks.trackPlaying, 
        trackPaused: state.tracks.trackPaused,
        user: state.account.user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //artist and track actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, trackActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlayPauseButtons);